import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Box, Typography } from "@components/base";

interface DropdownItemProps {
  label: string;
  color?: string;
  bgColor?: string;
  borderColor?: string;
  avatar?: ReactNode;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  label,
  color,
  bgColor,
  borderColor = "transparent",
  avatar,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      color={color}
      bgcolor={bgColor}
      border={`1px solid ${borderColor}`}
      borderRadius={0.5}
      p="2px 6px"
      alignItems="center"
      display="flex"
      gap={1}
    >
      {avatar && avatar}
      <Typography fontSize={12} fontWeight={500} whiteSpace="nowrap">
        {t(label)}
      </Typography>
    </Box>
  );
};
